import { get } from 'lodash';
import insurancePickerSelector from '@zocdoc/components/src/InsurancePicker/data/insurancePickerSelector';
import { getThemeParameters } from '../../../../config/theme/selector';
import { nextAvailabilitySelector } from '../NextAvailability/selector';
import { getProfilePageParameters } from '../../state/selectors';
import isZocdocBrand from '../../../../utils/isZocdocBrand';
import { showFindSimilarDoctors } from '../../../../config/ab/selector';

export default function mapStateToProps(state) {
    const { directoryId } = getThemeParameters(state);
    const nextAvailabilityState = nextAvailabilitySelector(state);
    const profilePageParameters = getProfilePageParameters(state);
    const insurancePickerState = insurancePickerSelector(state) || { };
    const is1Z = isZocdocBrand(directoryId);
    const carrierName = get(insurancePickerState, 'dropdownState.carrier.name', '');
    const planName = get(insurancePickerState, 'dropdownState.plan.name', '');

    return {
        bookingSpotlightIsOn: profilePageParameters.bookingSpotlightIsOn,
        carrierId: insurancePickerState.carrier,
        carrierName,
        directoryId,
        is1Z,
        nextAvailability: nextAvailabilityState.nextAvailability,
        planId: insurancePickerState.plan,
        planName,
        showFindSimilarDoctors: showFindSimilarDoctors(state),
    };
}
